import React, {useState} from "react";
import {styled} from "@stitches/react";
import {Button, CircularProgress} from "@material-ui/core";
import {useHistory} from "react-router";
import {Alert} from "@material-ui/lab";

import {PHONE_NUMBER} from "../../constants/company";

import {ContactDetails} from "./ContactDetails";
import {DeliveryDetails} from "./DeliveryDetails";
import {DeliveryTime} from "./DeliveryTime";
import {useNewOrderContext} from "./NewOrderContext";

export const NewOrderForm: React.FC<any> = () => {
  const {
    isDeliveryDetailsValid,
    isContactDetailsValid,
    isDeliveryTimeValid,
    isLoadingUserData,
    submitNewOrder,
    resetDeliveryTime,
  } = useNewOrderContext();
  const history = useHistory();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [serverErrorMessage, setServerErrorMessage] = useState("");
  const [availabilityRefreshToken, setAvailabilityRefreshToken] = useState(0);

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      setServerErrorMessage("");
      const newOrder = await submitNewOrder();
      const autoConfirmedQuery = newOrder.status === "confirmed" ? "&autoConfirmed=true" : "";
      history.push(`/orders?success=true${autoConfirmedQuery}`);
    } catch (e: any) {
      console.error(e);
      if (e?.response?.data?.code === "DELIVERY_SLOT_UNAVAILABLE") {
        resetDeliveryTime();
        setAvailabilityRefreshToken((current) => current + 1);
        setServerErrorMessage(
          e.response.data.message ||
            "That delivery option is no longer available. Please select another day or AM/PM option."
        );
      } else {
        setServerErrorMessage(
          `Uh oh! Our computers screwed up again. Please try again later or call us at ${PHONE_NUMBER}.`
        );
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoadingUserData) {
    return (
      <StyledCircularProgressContainer>
        <CircularProgress />
      </StyledCircularProgressContainer>
    );
  }

  return (
    <>
      <ContactDetails />
      <DeliveryDetails />
      <DeliveryTime availabilityRefreshToken={availabilityRefreshToken} />

      <StyledSubmitButtonWrapper>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleSubmit}
          disabled={
            !isDeliveryDetailsValid ||
            !isContactDetailsValid ||
            !isDeliveryTimeValid ||
            isSubmitting
          }
        >
          Submit
        </Button>

        {serverErrorMessage && (
          <StyledServerAlert severity="error">
            {serverErrorMessage}
          </StyledServerAlert>
        )}
      </StyledSubmitButtonWrapper>
    </>
  );
};

const StyledSubmitButtonWrapper = styled("div", {
  marginTop: "2rem",
});

const StyledServerAlert = styled(Alert, {
  marginTop: "2rem",
});

const StyledCircularProgressContainer = styled("div", {
  width: "100%",
  display: "flex",
  justifyContent: "center",
});
